'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconsPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var iconsPropType = exports.iconsPropType = {
  /** Turns on/off icon's border */
  border: _propTypes2.default.bool,

  /** Set icon's border width */
  borderWidth: _propTypes2.default.number,

  /** Make icon rounded */
  rounded: _propTypes2.default.bool,

  /** Set icon size */
  size: _propTypes2.default.oneOf(['custom', 'small', 'normal', 'large', 'xlarge']),

  /** Set icon's color scheme */
  colorScheme: _propTypes2.default.oneOf(['light', 'dark', 'default']),

  /** Set exact icon's border color */
  color: _propTypes2.default.string,

  /** Set icon's background color */
  backgroundColor: _propTypes2.default.string,

  /** Set icon's flipping plane */
  flip: _propTypes2.default.oneOf(['none', 'horizontal', 'vertical']),

  /** Rotate icon by some degree */
  rotate: _propTypes2.default.number
};